export const getUserClaims = async (userId, prefix, token) => {
  const url = prefix + `admin/users/${userId}/claims`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user claims:", error);
    throw error;
  }
};

export const setUserClaims = async (userId, claims, prefix, token) => {
  const url = prefix + `admin/users/${userId}/claims`;

  const body = {
    claims: claims,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error setting user claims:", error);
    throw error;
  }
};

export const addUserClaim = async (userId, claimKey, claimValue, prefix, token) => {
  try {
    const currentClaims = await getUserClaims(userId, prefix, token);
    
    const updatedClaims = {
      ...currentClaims.claims,
      [claimKey]: claimValue
    };
    
    return await setUserClaims(userId, updatedClaims, prefix, token);
  } catch (error) {
    console.error("Error adding user claim:", error);
    throw error;
  }
};

export const updateUserClaim = async (userId, claimKey, claimValue, prefix, token) => {
  try {
    const currentClaims = await getUserClaims(userId, prefix, token);
    
    const updatedClaims = {
      ...currentClaims.claims,
      [claimKey]: claimValue
    };
    
    return await setUserClaims(userId, updatedClaims, prefix, token);
  } catch (error) {
    console.error("Error updating user claim:", error);
    throw error;
  }
};

export const deleteUserClaim = async (userId, claimKey, prefix, token) => {
  try {
    const currentClaims = await getUserClaims(userId, prefix, token);
    
    const updatedClaims = { ...currentClaims.claims };
    delete updatedClaims[claimKey];
    
    return await setUserClaims(userId, updatedClaims, prefix, token);
  } catch (error) {
    console.error("Error deleting user claim:", error);
    throw error;
  }
};